<template>
	<nav ref="nav" v-bind="$attrs" class="omapi-dropdown omapi-dropdown__select">
		<core-button
			ref="button"
			color="white"
			size="small"
			type="secondary"
			:link-style="linkStyle"
			class="omapi-dropdown__toggle nohover"
			@click.prevent="toggle"
		>
			<!-- @slot Button Text/Content -->
			{{ '' !== currentValue ? currentValue : placeholder }}
		</core-button>
		<div v-show="!hidden" class="omapi-dropdown__container" :style="style">
			<!-- @slot Dropdown List -->
			<ul>
				<!-- Should be <li><a></a></li> format -->
				<slot name="list"></slot>
			</ul>
		</div>
	</nav>
</template>

<script lang="js">
export default {
	props: {
		/**
		 * Icon
		 */
		icon: {
			type: String,
			default: '',
		},
		/**
		 * Width
		 */
		width: {
			type: Number,
			default: null,
		},
		/**
		 * Link Style
		 */
		linkStyle: {
			type: Boolean,
			default: false,
		},
		/**
		 * Whether dropdown is open by default.
		 */
		opened: Boolean,
		/**
		 * Whether dropdown will stay open unless clicked closed.
		 */
		keepOpen: {
			type: Boolean,
			default: false,
		},
		/**
		 * How dropdown should align under the button. Default is
		 * aligned to the left.
		 */
		align: {
			type: String,
			default: 'left',
		},
		/**
		 * The current selected value which shows as the dropdown item
		 */
		currentValue: {
			type: String,
			required: true,
		},
		/**
		 * The current selected value which shows as the dropdown item
		 */
		placeholder: {
			type: String,
			default: 'Choose an option...',
		},
	},
	data() {
		return {
			hidden: true,
			navParent: null,
			button: null,
		};
	},
	computed: {
		style() {
			if (!this.navParent || !this.button) {
				return {};
			}

			const parentWidth = this.width || this.navParent.offsetWidth;
			const style = {
				width: `${parentWidth}px`,
			};

			switch (this.align) {
				// left is the default.
				case 'left': {
					style.left = 0;
					break;
				}
				case 'center': {
					style.left = `-${Math.floor((parentWidth - this.button.offsetWidth) / 2)}px`;
					break;
				}
				case 'right': {
					style.right = 0;
					break;
				}
			}

			return style;
		},
		/**
		 * Icon Classes
		 *
		 * @returns {string} The icon classes or empty string
		 */
		iconClasses() {
			return this.icon ? `fa fa-${this.icon}` : '';
		},
		/**
		 * Dropdown Class
		 *
		 * @returns {string} visible class or empty string
		 */
		dropdownClass() {
			return this.hidden ? '' : 'visible';
		},
	},
	mounted() {
		window.addEventListener('click', this.maybeClose);
		if (this.opened) {
			this.toggle();
		}
	},
	beforeDestroy() {
		window.removeEventListener('click', this.maybeClose);
	},
	methods: {
		/**
		 * Toggle Dropdown Visability
		 *
		 * @returns {void}
		 */
		toggle() {
			const navParent = this.$get('$refs.nav.parentElement');
			if (!this.navParent && navParent) {
				this.navParent = navParent;
			}

			const button = this.$get('$refs.button.$refs.button');
			if (!this.button && button) {
				this.button = button;
			}

			this.hidden = !this.hidden;
		},
		/**
		 * Close when clicking outside our elements or when selecting an option (if keepOpen isn't true)
		 *
		 * @param {object} evt The event object.
		 *
		 * @returns {void}
		 */
		maybeClose(evt) {
			if (!this.hidden && !this.keepOpen) {
				const nav = this.$get('$refs.nav');
				const options = this.$get('$refs.nav.lastChild.firstChild.childNodes');
				let isMe = evt.target === nav;
				let isOption = Object.values(options).includes(evt.target.parentNode);
				if (!isMe && nav) {
					isMe = nav.contains(evt.target);
				}
				if (!isMe || isOption) {
					this.toggle();
				}
			}
		},
	},
};
</script>

<style scoped lang="scss">
nav {
	display: inline-block;
	position: relative;
}
</style>
